/** Canonical pure semantics, shared by the host and native editor. */



/**
 * ✂️ **이 소스는 구간 컷이라 영상 릴레이를 못 탄다** — 차단 판정 ★SSOT★.
 *
 * ★화면 고지가 같은 술어를 봐야 한다(적대 3R P3)★: 차단만 하고 말을 안 하면, 유저에겐 "어제까지
 *   뜨던 🎞 이어붙이기 배너가 컷을 나눈 뒤 그냥 사라진" 것으로 보인다 — 이유도 대안도 없는 침묵이다.
 *   `resolveUserChainRef` 와 인스펙터 배너가 이 함수 하나를 공유해야 판정과 고지가 안 갈린다.
 */
export function isTrimmedRelaySource(source: { clipStartSec?: number | null } | null | undefined): boolean {
  return typeof source?.clipStartSec === "number" && Number.isFinite(source.clipStartSec);
}
